module.exports = "/static/assets/b23338257a9f7218996f0da6e16b6d6a.png";